import { render, staticRenderFns } from "./VersionSwitchBanner.vue?vue&type=template&id=694eba0c&scoped=true"
import script from "./VersionSwitchBanner.vue?vue&type=script&lang=js"
export * from "./VersionSwitchBanner.vue?vue&type=script&lang=js"
import style0 from "./VersionSwitchBanner.vue?vue&type=style&index=0&id=694eba0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694eba0c",
  null
  
)

export default component.exports